import { gql } from "@apollo/client"

const UPDATE_CUSTOMER = gql`
  mutation UpdateUser(
    $firstName: String!
    $lastName: String!
    $id: ID!
  ) {
    updateUser(
      input: {
        id: $id
        firstName: $firstName
        lastName: $lastName
      }
    ) {
      user {
        firstName
        lastName
      }
    }
  }
`

export default UPDATE_CUSTOMER
